var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPortalBroadcast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46447 14.4645C8.07394 14.855 8.07394 15.4882 8.46447 15.8787C8.85499 16.2692 9.48816 16.2692 9.87868 15.8787C11.0503 14.7071 12.9497 14.7071 14.1213 15.8787C14.5118 16.2692 15.145 16.2692 15.5355 15.8787C15.9261 15.4882 15.9261 14.855 15.5355 14.4645C13.5829 12.5118 10.4171 12.5118 8.46447 14.4645Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63604 11.636C5.24552 12.0266 5.24552 12.6597 5.63604 13.0503C6.02657 13.4408 6.65973 13.4408 7.05025 13.0503C9.78392 10.3166 14.2161 10.3166 16.9497 13.0503C17.3403 13.4408 17.9734 13.4408 18.364 13.0503C18.7545 12.6597 18.7545 12.0266 18.364 11.636C14.8492 8.12132 9.15076 8.12132 5.63604 11.636Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80761 8.80761C2.41709 9.19814 2.41709 9.8313 2.80761 10.2218C3.19814 10.6124 3.8313 10.6124 4.22183 10.2218C8.51472 5.92893 15.4853 5.92893 19.7782 10.2218C20.1687 10.6124 20.8019 10.6124 21.1924 10.2218C21.5829 9.8313 21.5829 9.19814 21.1924 8.80761C15.7279 3.34315 8.27208 3.34315 2.80761 8.80761Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPortalBroadcast);
export default ForwardRef;